declare namespace $ {

	export class $mol_icon_language_markdown extends $mol_icon {
		path( ): string
	}
	
}

//# sourceMappingURL=markdown.view.tree.d.ts.map